/*=============================================== KeyPage ===============================================*/

import { Key } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import { commonProps } from "data"

const KeyPage = () => {
    const items: ItemType[] = [
        {
            title: "Without separator",
            content: <Key keys={["⌘", "K"]} />,
            code: '<Key keys={["⌘", "K"]} />',
        },
        {
            title: "With separator",
            content: (
                <Key keys={["⌘", "K"]} withSeparator accentColor="secondary" />
            ),
            code: '<Key keys={["⌘", "K"]} withSeparator accentColor="secondary" />',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "keys",
            type: "array of strings",
            required: true,
        },
        {
            subtitle: "withSeparator",
            type: "boolean",
        },
        {
            subtitle: "accentColor",
            type: "string",
            possible: commonProps.colorsHover,
            default: "primary",
        },
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default KeyPage
